/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_TitleInputs */

const en_svc_automation_title = /** @type {(inputs: Svc_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automation`)
};

const ar_svc_automation_title = /** @type {(inputs: Svc_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأتمتة`)
};

const bn_svc_automation_title = /** @type {(inputs: Svc_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অটোমেশন`)
};

const de_svc_automation_title = /** @type {(inputs: Svc_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisierung`)
};

const es_svc_automation_title = /** @type {(inputs: Svc_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatización`)
};

const fr_svc_automation_title = /** @type {(inputs: Svc_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisation`)
};

const pt_svc_automation_title = /** @type {(inputs: Svc_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automação`)
};

const zh_svc_automation_title = /** @type {(inputs: Svc_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动化`)
};

const tr_svc_automation_title = /** @type {(inputs: Svc_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otomasyon`)
};

const ru_svc_automation_title = /** @type {(inputs: Svc_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматизация`)
};

const pl_svc_automation_title = /** @type {(inputs: Svc_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatyzacja`)
};

/**
* | output |
* | --- |
* | "Automation" |
*
* @param {Svc_Automation_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_automation_title = /** @type {((inputs?: Svc_Automation_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_title(inputs)
	if (locale === "bn") return bn_svc_automation_title(inputs)
	if (locale === "de") return de_svc_automation_title(inputs)
	if (locale === "es") return es_svc_automation_title(inputs)
	if (locale === "fr") return fr_svc_automation_title(inputs)
	if (locale === "pt") return pt_svc_automation_title(inputs)
	if (locale === "zh") return zh_svc_automation_title(inputs)
	if (locale === "tr") return tr_svc_automation_title(inputs)
	if (locale === "ru") return ru_svc_automation_title(inputs)
	if (locale === "pl") return pl_svc_automation_title(inputs)
	return en_svc_automation_title(inputs)
});